import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

class RedialChart extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
      
        series: [55, 67, 80],
        options: {
          chart: {
            height: 350,
            type: 'radialBar',
          },
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: '22px',
                },
                value: {
                  fontSize: '16px',
                },
                total: {
                  show: true,
                  label: 'Total',
                  formatter: function (w) {
                    // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                    return 1150
                  }
                }
              }
            }
          },
          labels: ['Oct 2024 - Oct 2025', 'Oct- Nov - Dec' ,new Date().toLocaleString('en-US', { month: 'long' , year: 'numeric' })],
        },
      
      
      };
    }

  

    render() {
      return (
        <div>
          <div id="chart">
            <ReactApexChart options={this.state.options} series={this.state.series} type="radialBar" height={350} />
          </div>
          <div id="html-dist"></div>
        </div>
      );
    }
  }
export default RedialChart;